// gift-token.js
//
// Mints the gift booking token and keeps it on the cart.
//
// A gift is claimed by whoever holds the booking link, so that link needs an
// unguessable secret in it. The secret is a cart *attribute* rather than a
// line-item property: attributes are order-scoped, so one token covers every
// workshop on the order and the recipient gets a single link that walks them
// through the workshops in the right order.
//
// It is minted here, before checkout, rather than by the webhook afterwards,
// because Shopify sends the order-confirmation email as the order is created —
// before any webhook of ours could write to it. A cart attribute is already on
// the order by then, so the email can render a working link.
//
// Exposes window.NegDevGiftToken.ensure(), which resolves to the cart's token,
// creating one only if the cart does not already have it.
//
// IMPORTANT: call this only once the cart HAS ITEMS. Shopify silently discards
// attributes written to an empty cart — /cart/update.js still answers 200, and
// the attribute is simply not there afterwards. Both purchase paths used to
// mint before adding the item, so from the first gift order through to
// #N1824G, not one order ever carried a token: every confirmation email was
// built without a booking link. ensure() now reads the cart back and rejects
// if the write did not stick, so the same failure cannot pass unnoticed again.
(function () {
  var ATTRIBUTE = '_gift_token';

  function randomToken() {
    var bytes = new Uint8Array(16);
    // Cryptographic RNG, not Math.random(): this value is the credential that
    // protects someone's gift, and Math.random() is predictable from earlier
    // outputs.
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    var out = '';
    for (var i = 0; i < bytes.length; i++) {
      out += (bytes[i] + 0x100).toString(16).slice(1);
    }
    return out;
  }

  function ensure() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = cart && cart.attributes && cart.attributes[ATTRIBUTE];
        // Reuse an existing token. Regenerating it on every cart change would
        // invalidate a link that may already have been emailed.
        if (existing) return existing;

        var token = randomToken();
        var attributes = {};
        attributes[ATTRIBUTE] = token;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes }),
          // Callers wait for this before submitting, so it should already have
          // finished. keepalive means that if a navigation starts anyway the
          // browser still delivers the request instead of cancelling it —
          // cheap insurance on the write that makes the gift link work.
          keepalive: true
        }).then(function (resp) {
          if (!resp.ok) throw new Error('Could not store the gift token on the cart');
          // Read it back. A 200 here does not mean the attribute persisted:
          // on an empty cart Shopify accepts the write and drops the value.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (saved) {
              var stored = saved && saved.attributes && saved.attributes[ATTRIBUTE];
              if (stored !== token) {
                throw new Error(
                  'Gift token did not persist on the cart. The cart was probably ' +
                  'empty when ensure() ran — add the item first, then mint.'
                );
              }
              return token;
            });
        });
      });
  }

  window.NegDevGiftToken = { ensure: ensure, ATTRIBUTE: ATTRIBUTE };
})();
